import { h, Host } from "@stencil/core";
/**
 * @slot (default) - Content of the label
 * @slot "other" - Additional content is placed below the label element
 */
export class InputLabel {
    constructor() {
        this.text = "";
        this.labelClasses = null;
        this.labelId = "";
        this.inputId = "";
        this.required = false;
        this.error = false;
        this.errorMsg = "";
        this.labelInfo = "";
        this.as = "label";
    }
    host;
    render() {
        const { text, labelClasses, labelId, required, error, errorMsg, inputId, labelInfo, as } = this;
        const baseClass = "ux-input-label";
        const labelClass = "ux-label";
        const hasErrorMsg = errorMsg && errorMsg.length > 0;
        const hasLabelText = text && text.length > 0;
        const hasLabelInfo = labelInfo !== "";
        const hasContent = hasLabelText || hasLabelInfo || hasErrorMsg;
        const Tag = as;
        return (h(Host, { key: '4cd967a10e9c7b5972f41ff4f88e72d950e24c75', class: `${baseClass}` }, h(Tag, { key: 'c9d17021bd260bb2e2c65565dc3fc2dec01c2b8f', htmlFor: inputId || undefined, id: labelId || undefined, class: {
                [labelClass]: true,
                // @ts-expect-error Check for typing
                [labelClasses]: labelClasses !== null,
                [`${labelClass}--required`]: required,
                [`${labelClass}--error`]: error && !hasErrorMsg,
                [`${labelClass}--empty`]: !hasContent
            }, "aria-hidden": hasContent ? undefined : "true" }, hasLabelText && h("span", { key: '0077d19cac6dcb8a40a813befa5912c00c84d10e', class: `${labelClass}__text` }, text), hasLabelInfo && h("span", { key: 'a075bdcf49a629438844eb1566f0e8b392e20d11', class: `${labelClass}__info` }, labelInfo), h("slot", { key: '8ac1c6a7d33a6d1ce30e8da173a9a2f6b9414ecd' }), hasErrorMsg && error && (h("span", { key: '70e884e2ae2bd7c6865978d058a4b3dbba4289df', class: {
                [`${labelClass}__error-message`]: true
            } }, errorMsg))), h("slot", { key: 'b3e05f7e4594e4c0d7cfe06240f3d58a3fb6ab0a', name: "other" })));
    }
    static get is() { return "ux-input-label"; }
    static get originalStyleUrls() {
        return {
            "$": ["input-label.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["input-label.css"]
        };
    }
    static get properties() {
        return {
            "text": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Text of the label"
                },
                "attribute": "text",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "labelClasses": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string | null",
                    "resolved": "null | string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Additional classs added to the label"
                },
                "attribute": "label-classes",
                "reflect": false,
                "defaultValue": "null"
            },
            "labelId": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The id attribute of the label"
                },
                "attribute": "label-id",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "inputId": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The id attribute of the related input element"
                },
                "attribute": "input-id",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "required": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Indicates a mandatory input"
                },
                "attribute": "required",
                "reflect": false,
                "defaultValue": "false"
            },
            "error": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Indicates that the related input value is invalid"
                },
                "attribute": "error",
                "reflect": false,
                "defaultValue": "false"
            },
            "errorMsg": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "An error message that is rendered if `error` is set to `true`"
                },
                "attribute": "error-msg",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "labelInfo": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Additional info label for the the input field"
                },
                "attribute": "label-info",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "as": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "\"label\" | \"legend\"",
                    "resolved": "\"label\" | \"legend\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "additional info label for the the input field"
                },
                "attribute": "as",
                "reflect": false,
                "defaultValue": "\"label\""
            }
        };
    }
    static get elementRef() { return "host"; }
}
//# sourceMappingURL=input-label.js.map
